import { TFunction } from 'i18next';
import {
  ApprovalType,
  FilterPassport,
  FilterStatus,
  PeriodStatus,
} from '@/types/api';

type SummaryItem = ApprovalType | FilterPassport | FilterStatus | PeriodStatus;

/**
 * 등록기간 필터의 라벨을 만든다.
 * - 직접설정(type === 3): "시작일 ~ 종료일"
 * - 프리셋(type !== 3): 프리셋명(예: 최근 30일)
 * Module/SelectedButton/Contents 의 개별 삭제 칩과 FilterBar 칩 트리거가 공유한다.
 */
export const formatPeriodLabel = (period: PeriodStatus, t: TFunction): string =>
  period.type === 3
    ? `${period.value} ~ ${period.value2}`
    : t(`${period.name}`);

export type ChipSummary = { label: string; extraCount: number } | null;

/**
 * 필터 칩 트리거에 인라인으로 표시할 요약("첫 항목명" + 나머지 개수)을 만든다.
 * @param isPeriod 등록기간 필터면 formatPeriodLabel 로 첫 항목 라벨 생성
 * @param context 번역 context — 상태 필터는 'status' 로 상태 칩과 같은 표기
 */
export const getChipSummary = (
  items: SummaryItem[],
  t: TFunction,
  isPeriod = false,
  context?: string,
): ChipSummary => {
  if (!items.length) return null;
  const [first] = items;
  const label = isPeriod
    ? formatPeriodLabel(first as PeriodStatus, t)
    : t(`${(first as { name: string }).name}`, { context });
  return { label, extraCount: items.length - 1 };
};
